var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"v-data-table-header"},[_c('tr',{class:{ 'vx-data-list-headers': true, collapsed: _vm.hideHeader }},_vm._l((_vm.parsedHeaders),function(header,index){return _c('VxTableHeaderCell',{key:index,class:header.cssClass,attrs:{"type":"date","date-format":_vm.dateFormat,"value":header.label,"align":header.align}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }